module.exports = __webpack_public_path__ + "img/menu-login.d3e197ba.svg";